// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2sLOb","title":"Images90_title__2sexf","images":"Images90_images__Y5_5g"};